<div class="page-container">
	<div class="page-body-container" *ngIf="isPaid">
		<div class="card prepay-wrapper">
			<strong class="order-headline">Die Bestellungen wurde bezahlt.</strong>
			<p class="pt-0!">Wenn Sie einen Account bei uns haben, können Sie die Bestellung in der Historie
				einsehen.</p>
		</div>
	</div>
	<div class="page-body-container" *ngIf="!isPaid">
		<div class="card prepay-wrapper" *ngIf="!payment">
			<strong class="order-headline">Keine Bestellung gefunden</strong>
			<p class="pt-0!">Wir konnten keine offenen Bestellungen finden.</p>
		</div>

		<div class="card prepay-wrapper" *ngIf="payment?.method == 'prepayment'">
			<strong class="order-headline">Vorkasse QR-Code</strong>
			<p class="pt-0!">Bitte scannen Sie nachfolgenden Code oder überweisen sie manuell an:</p>

			<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
				<strong>Name:</strong>
				<span>{{ payment.payment.account_owner }}</span>

                <strong>Bank:</strong>
                <span>{{ payment.payment.bank }}</span>

				<strong>IBAN:</strong>
				<span>{{ payment.payment.iban }}</span>

                <ng-container *ngIf="payment.payment.bic">
				<strong>BIC:</strong>
				<span>{{ payment.payment.bic }}</span>
                </ng-container>


				<strong>Verwendungszweck:</strong>
				<span>{{ payment.payment.reference }}</span>

				<strong>Betrag:</strong>
				<span>{{ payment.totalGrossAmount | currency:'EUR' }}</span>
				@if (payment.payment.link) {
					<strong>Link</strong>
					<span>{{ payment.payment.link }}</span>
				}
			</div>
			<img class="h-auto max-w-full mx-auto" *ngIf="prepayment_qr_code" [src]="prepayment_qr_code"/>
		</div>

		<div class="card prepay-wrapper" *ngIf="payment?.method == 'paypal' && payment?.payment?.link">
			<strong class="order-headline">PayPal</strong>
			<p class="pt-0!">Bitte bezahlen Sie über folgenden Link.</p>
			<a class="btn-primary mt-4" [href]="payment.payment.link">
				<span>Mit PayPal bezahlen</span>

				<i class="fa-solid fa-angle-right self-center text-md pl-2"></i>
			</a>
		</div>
		<div class="card prepay-wrapper" *ngIf="payment?.method == 'pickup'">
			<strong class="order-headline">Bezahlung bei Abholung</strong>
			<p class="pt-0!">Bitte bezahlen Sie Ihre Rechnung in der Apotheke.</p>
		</div>

		<form *ngIf="!prepayment_qr_code && payment && !payment?.payment?.link && payment.method !== 'pickup'" class="w-full" [formGroup]="orderForm"
			  (ngSubmit)="onSubmit()">
			<div class="inner-content grid md:gap-4 grid-cols-6">
				<div *ngIf="payment" class="card col-span-6 md:col-span-2">
					<strong class="order-headline">Artikel</strong>

					<mat-card *ngFor="let item of payment.order.invoicePositions">
						<div>
							<span class="w-1/2 inline-block text-preorder-primary">Name:</span>
							<span class="inline-block w-1/2 text-right text-preorder-primary">{{ item.name }}</span>
						</div>
						<div>
							<span class="w-1/2 inline-block text-preorder-primary">Menge:</span>
							<span class="inline-block w-1/2 text-right text-preorder-primary">{{ item.amount }} {{ item.unitOfMeasurement }}</span>
						</div>
						<div>
							<span class="w-1/2 inline-block text-preorder-primary">Preis:</span>
							<span class="inline-block w-1/2 text-right text-preorder-primary">{{ item.nettoPrice | currency:'EUR' }}</span>
						</div>
						<div>
							<span class="w-1/2 inline-block text-preorder-primary">Gesamt:</span>
							<span class="inline-block w-1/2 text-right text-preorder-primary">{{ item.amount * item.nettoPrice | currency:'EUR' }}</span>
						</div>

						<hr class="my-2"/>
					</mat-card>
					<table class="mat-mdc-table w-full">
						<tbody>
						@if (selectedShippingMethod && selectedShippingMethod.name !== 'Abholung') {
							<tr class="mat-mdc-row">
								<td class="mat-mdc-cell">
									<strong>Versandkosten</strong>
								</td>
								<td class="mat-mdc-cell text-right">{{ selectedShippingMethod.nettoPrice | currency:'EUR' }}</td>
							</tr>
						}
						<tr class="mat-mdc-row">
							<td class="mat-mdc-cell">
								<strong>Zwischensumme netto</strong>
							</td>
							<td class="mat-mdc-cell text-right">{{ payment | partialSum:selectedShippingMethod | currency:'EUR' }}</td>
						</tr>


						<tr class="mat-mdc-row">
							<td class="mat-mdc-cell">
								<strong>USt 19%</strong>
							</td>
							<td class="mat-mdc-cell text-right">
								{{ payment | partialSum:selectedShippingMethod | vat: payment.order.invoicePositions[0].vat | currency:'EUR' }}
							</td>
						</tr>
						<tr class="mat-mdc-row sum-row">
							<td class="mat-mdc-cell">
								<strong>Gesamtbetrag</strong>
							</td>
							@if (selectedShippingMethod && selectedShippingMethod.nettoPrice) {
								<td class="mat-mdc-cell text-right">{{ (payment | totalSum) + selectedShippingMethod.nettoPrice + (selectedShippingMethod.nettoPrice * (selectedShippingMethod.vat / 100)) | currency:'EUR' }}</td>
							} @else {
								<td class="mat-mdc-cell text-right">{{ (payment | totalSum) | currency:'EUR' }}</td>
							}
						</tr>
						</tbody>
					</table>
					@if (shippingMethods.length > 0 && shippingMethods[shippingMethodShippingIndex]?.freeAboveGross !== 0) {
						<div class="text font-bold mt-4">
							<span>Ab einem Warenwert von </span>
							<span> {{ shippingMethods[shippingMethodShippingIndex].freeAboveGross }}€ </span>
							<span>ist der Versand kostenlos.</span>
						</div>
					}
				</div>
				<div class="card col-span-6 md:col-span-4">
					<div class="general-wrapper mb-8">
						<strong class="order-headline">Logindaten</strong>
						<ul class="mb-4">
							<li>
								Kein Konto? Einfach ein Passwort angeben – wir legen eins für Sie an.
							</li>
							<li>
								Konto schon vorhanden? Passwortfeld leer lassen – Ihre Bestellung wird automatisch zugeordnet.
							</li>
							<li>
								Ein Konto ist nicht nötig, aber praktisch zur Einsicht Ihrer Bestellhistorie.
							</li>
						</ul>

						<div class="pb-2">
							<div class="text">Schon registriert aber keine Bestätigungsmail erhalten? Dann klicken Sie bitte
								<span class="text underline cursor-pointer hover:text-canna-secondary"
									 (click)="openResendLinkModal()">hier.
								</span>
							</div>
						</div>

						<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" formGroupName="general">
							<div class="form-group">
								<div class="form-control">
									<label>E-Mail</label>
									<input type="email" matInput placeholder="E-Mail" formControlName="email">
								</div>
							</div>

							<div class="form-group">
								<div class="form-control">
									<label>Passwort</label>
									<input [type]="hidePassword ? 'password' : 'text'" matInput placeholder="Passwort"
										   formControlName="password">
									<i class="fa-solid absolute right-3 top-11 text-preorder-accordion-background text-xl cursor-pointer"
									   (click)="hidePassword = !hidePassword"
									   [ngClass]="{'fa-eye': !hidePassword, 'fa-eye-slash': hidePassword}"></i>
									@if (orderForm.get('general.password')!.dirty && orderForm.get('general.password')!.errors) {
										<div class="flex flex-col gap-2">

											@if (orderForm.get('general.password')!.errors!['minLength']) {
												<div class="text-preorder-orange text-sm">- Mindestens 12
													Zeichen
												</div>
											}
											@if (orderForm.get('general.password')!.errors!['minLowerCase']) {
												<div class="text-preorder-orange text-sm">- Mindestens 1
													Kleinbuchstabe
												</div>
											}
											@if (orderForm.get('general.password')!.errors!['minUpperCase']) {
												<div class="text-preorder-orange text-sm">- Mindestens 1
													Großbuchstabe
												</div>
											}
											@if (orderForm.get('general.password')!.errors!['minDigits']) {
												<div class="text-preorder-orange text-sm">- Mindestens 1 Ziffer
												</div>
											}
											@if (orderForm.get('general.password')!.errors!['minSpecialCharacters']) {
												<div class="text-preorder-orange text-sm">- Mindestens 1
													Sonderzeichen
												</div>
											}

										</div>
									}
								</div>
							</div>
						</div>

						<strong class="order-headline">Lieferung & Bezahlung</strong>
						<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
							<div class="form-group" formGroupName="general" *ngIf="shippingMethods.length > 0">
								<div class="form-control">
									<label>Liefermethode*</label>
									<mat-select (selectionChange)="onShippingMethodChange($event)" formControlName="shippingMethod" [disabled]="selectedPayment === 'pickup'">
										<mat-option [value]="''">Bitte wählen</mat-option>
										@for (method of shippingMethods; track method.id) {
											<mat-option [value]="method">
												<div class="flex gap-1">
													<span>{{ method.name }}</span>
													@if (method.name != 'Abholung') {
														<span> - </span>
														<span>{{ method.nettoPrice + (method.nettoPrice * (method.vat / 100)) | currency:'EUR' }}</span>
													}
												</div>
											</mat-option>
										}
									</mat-select>
								</div>
							</div>

							<div class="form-group" formGroupName="general" *ngIf="shippingMethods.length === 0">
								<div class="form-control">
									<label>Liefermethode*</label>
									<input matInput disabled value="{{selectedShippingMethod.name}}">
								</div>
							</div>

							<div class="form-group" formGroupName="general">
								<div class="form-control">
									<label>Zahlungsmethode*</label>
									<mat-select formControlName="method" (selectionChange)="onPaymentMethodChange($event)">
										<mat-option [value]="''" selected disabled>Bitte wählen</mat-option>
										@for (method of paymentMethods; track method.name) {
											<mat-option [value]="method.value" [disabled]="method.disabled">{{ method.name }}</mat-option>
										}
									</mat-select>
								</div>
							</div>
						</div>

						<strong class="order-headline">Meine Daten</strong>
						<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
							<div class="form-group" formGroupName="address">
								<div class="form-control">
									<label>Anrede</label>
									<mat-select formControlName="salutation">
										<mat-option [value]="''">Bitte wählen</mat-option>
										<mat-option [value]="'Herr'">Herr</mat-option>
										<mat-option [value]="'Frau'">Frau</mat-option>
										<mat-option [value]="'Divers'">Divers</mat-option>
									</mat-select>
								</div>
							</div>
							<div class="form-group" formGroupName="address">
								<div class="form-control">
									<label>Vorname*</label>
									<input matInput placeholder="Vorname" formControlName="firstName">
								</div>
							</div>

							<div class="form-group" formGroupName="address">
								<div class="form-control">
									<label>Nachname*</label>
									<input matInput placeholder="Nachname" formControlName="lastName">
								</div>
							</div>

							<div class="form-group" formGroupName="address">
								<div class="form-control">
									<label>Geburtsdatum</label>
									<div class="datepicker-range">
										<input matInput [matDatepicker]="picker" formControlName="dateOfBirth"
											   class="w-full" placeholder="DD.MM.YYYY">
										<mat-datepicker-toggle [for]="picker"
															   matIconSuffix></mat-datepicker-toggle>
										<mat-datepicker #picker [touchUi]="isMobile"></mat-datepicker>
									</div>
								</div>
							</div>

							<div class="form-group" formGroupName="address">
								<div class="form-control">
									<label>Telefon*</label>
									<input matInput placeholder="Telefon" formControlName="phoneNumber">
								</div>
							</div>

							<div></div>
						</div>
					</div>

					<div class="address-wrapper mb-8" formGroupName="address">
						<strong class="order-headline">Rechnungsadresse</strong>
						<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
							<div class="form-group">
								<div class="form-control">
									<label>Stadt*</label>
									<input matInput placeholder="Stadt" formControlName="city">
								</div>
							</div>

							<div class="form-group">
								<div class="form-control">
									<label>
										@if (streetFieldSeperated) {
											Straße*
										} @else {
											Straße/Hausnummer*
										}
									</label>
									<input matInput placeholder="Straße" formControlName="street">
								</div>
							</div>

							<div class="form-group" *ngIf="streetFieldSeperated">
								<div class="form-control">
									<label>Hausnummer*</label>
									<input matInput placeholder="Hausnummer" formControlName="houseNumber">
								</div>
							</div>

							<div class="form-group">
								<div class="form-control">
									<label>Postleitzahl*</label>
									<input matInput placeholder="Postleitzahl" formControlName="zipCode">
								</div>
							</div>
						</div>
						<div class="form-group mt-4">
							<div class="form-control">
								<mat-slide-toggle [disabled]="payment && !payment.order.needsConfirmation"
												  [checked]="deliveryAddressActive"
												  (change)="toggleDeliveryAddress($event.checked)">
									<span>abweichende Lieferadresse</span>
								</mat-slide-toggle>
							</div>
						</div>
					</div>

					<div *ngIf="deliveryAddressActive" class="delivery-address-wrapper mb-8"
						 formGroupName="deliveryAddress">
						<strong class="order-headline">Lieferadresse</strong>
						<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
							<div class="form-group">
								<div class="form-control">
									<label>Anrede</label>
									<mat-select formControlName="salutation">
										<mat-option [value]="''">Bitte wählen</mat-option>
										<mat-option [value]="'Keine Angabe'">Keine Angabe</mat-option>
										<mat-option [value]="'Herr'">Herr</mat-option>
										<mat-option [value]="'Frau'">Frau</mat-option>
										<mat-option [value]="'Divers'">Divers</mat-option>
									</mat-select>
								</div>
							</div>
							<div class="form-group">
								<div class="form-control">
									<label>Vorname*</label>
									<input matInput placeholder="Vorname" formControlName="firstName">
								</div>
							</div>

							<div class="form-group">
								<div class="form-control">
									<label>Nachname*</label>
									<input matInput placeholder="Nachname" formControlName="lastName">
								</div>
							</div>

							<div class="form-group">
								<div class="form-control">
									<label>Geburtsdatum</label>
									<div class="datepicker-range">
										<input matInput [matDatepicker]="picker" formControlName="dateOfBirth"
											   class="w-full">
										<mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
										<mat-datepicker #picker></mat-datepicker>
									</div>
								</div>
							</div>

							<div class="form-group">
								<div class="form-control">
									<label>Telefon*</label>
									<input matInput placeholder="Telefon" formControlName="phoneNumber">
								</div>
							</div>

							<div class="form-group">
								<div class="form-control">
									<label>Stadt*</label>
									<input matInput placeholder="Stadt" formControlName="city">
								</div>
							</div>

							<div class="form-group">
								<div class="form-control">
									<label>Straße*</label>
									<input matInput placeholder="Straße" formControlName="street">
								</div>
							</div>

							<div class="form-group" *ngIf="streetFieldSeperated">
								<div class="form-control">
									<label>Hausnummer*</label>
									<input matInput placeholder="Hausnummer" formControlName="houseNumber">
								</div>
							</div>

							<div class="form-group">
								<div class="form-control">
									<label>Postleitzahl*</label>
									<input matInput placeholder="Postleitzahl" formControlName="zipCode">
								</div>
							</div>
						</div>
					</div>
					<div class="agreements flex flex-col">
						<mat-checkbox [(ngModel)]="dataProtectionAgreementAccepted" [ngModelOptions]="{standalone: true}">
							<span class="text-md underline hover:text-canna-secondary" (click)="toDataProtectionSite(); $event.preventDefault()">Datenschutzbestimmungen</span><span class="text-md"> gelesen und aktzeptiert</span>
						</mat-checkbox>
						<mat-checkbox [(ngModel)]="termsAndConditionsAccepted" [ngModelOptions]="{standalone: true}">
							<span class="text-md underline hover:text-canna-secondary" (click)="toAgbsPage(); $event.preventDefault()">AGBs</span><span class="text-md"> gelesen und aktzeptiert</span>
						</mat-checkbox>
					</div>
					<button class="btn-primary mt-4">
						@if (payment && payment.order.needsConfirmation) {
							<span>Bestätigen & bezahlen</span>
						} @else {
							<span>Bezahlen</span>
						}

						<i class="fa-solid fa-angle-right self-center text-md pl-2"></i>
					</button>
				</div>
			</div>
		</form>
	</div>
</div>
